import React from 'react'
import { AlertProps, Alert as MuiAlert } from '@mui/material'

const Alert = (props: AlertProps) => {
  const { ...rest } = props

  return <MuiAlert {...rest} />
}
export default Alert
